import request from '@/utils/request';

export function getCaptcha() {
  return request({
    url: '/captchaImage',
    method: 'get'
  });
}

export function login(username, password, code, uuid) {
  return request({
    url: '/login',
    method: 'post',
    data: { username, password, code, uuid }
  });
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  });
}
